import { useAuth } from '../context/AuthProvider';

// Page profil (protégée)
function Profile() {
    const { user, logout } = useAuth();

    return (
        <section className="max-w-md mx-auto px-8 py-16">
            <h1 className="text-4xl font-bold mb-10">Profile</h1>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-8 space-y-4">
                <div>
                    <p className="text-sm text-gray-400">Name</p>
                    <p className="text-lg font-semibold">{user?.name}</p>
                </div>
                <div>
                    <p className="text-sm text-gray-400">Email</p>
                    <p className="text-lg">{user?.email}</p>
                </div>
                <div>
                    <p className="text-sm text-gray-400">Role</p>
                    <p className="text-lg">{user?.role}</p>
                </div>
                <button onClick={logout} className="w-full bg-red-600 hover:bg-red-500 text-white px-6 py-3 rounded-lg font-semibold mt-4">Logout</button>
            </div>
        </section>
    );
}

export default Profile;